<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"margin-top:50px;"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-section-201 v-bind='{...{"mediaType":"video","image":"https:\/\/api.bazrafkantile.ir\/storage\/contents\/Sequence 01 1(1).mp4","alt":"","controls":true,"videoSrc":"https:\/\/api.mixitweb.com\/storage\/assets\/shakhsi.mp4","autoplay":true,"muted":true,"loop":true,"poster":null},...{}}' :style='"height:50vh;\n\n"' class="p-2 py-5" >
                <template #bottom-1>   </template>
                
                <template #bottom-2>   </template>
                
                <template #bottom-3>   </template>
                
                <template #mid-1>   </template>
                
                <template #mid-2>   <m-h1 v-bind='{...{},...{}}' :style='"padding: 5px 0 ;"' class="" >
                <template #default>وبسایت مدیریت باشگاهی   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>یک وبسیات باشگاهی به شما کمک میکند تا باشگاه و مشترکین باشگاهی خود را بهتر مدیریت کنید و با آنها بهتر در ارتباط باشیدحتی میتوانید مکمل ها و محصولات و حتی آموزش های حرکات ورزشی را در سایت بارگذاری کنید   </template>
                </m-p></template>
                
                <template #mid-3>   </template>
                
                <template #top-1>   </template>
                
                <template #top-2>   </template>
                
                <template #top-3>   </template>
                </m-section-201></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>ویژگی ها   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>با میکسیت وب مدرن ترین و کاربردی ترین ویژگی ها را بدست بیاورید    </template>
                </m-p><m-content-slider-4 v-bind='{...{"cardLink":false,"contentCategory":["sherkati-katalog"],"contentType":"page","slicer":null,"itemClass":"col-lg-3 my-2","waitForCategoryProp":false,"categoryColumnProp":"slug","contentCard":"mContentCard316","sliderPagination":true,"swiperPerViewSM":1,"swiperPerViewMD":2,"swiperPerViewLG":4,"swiperPerViewSpaceBetweenSM":30,"swiperPerViewSpaceBetweenMD":30,"swiperPerViewSpaceBetweenLG":30,"sliderGridStatus":false,"sliderGridRows":2,"sliderLoop":false,"contentDirectLinkOn":false},...{}}' :style='""' class="col" ></m-content-slider-4></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="text-center container" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="col-12 text-center my-4" >
                <template #default>نمونه کارها   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='"border-radius: 15px;"' class="col-12 text-center d-inline " >
                <template #default>روی هر کدوم از کارت ها بزنی سایتش باز میشه   </template>
                </m-p><m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto my-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-md-4 col-sm-6" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/salehigym.ir\/","target":"_blank"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:15px;\ntransition: all 0.1s ease-in-out;\n"' class="row mx-autojustify-content-center p-2 bg-white shadow m-2 align-items-center website-card-content" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.salehigym.ir\/storage\/assets\/logo.png","alt":"\u0628\u0627\u0634\u06af\u0627\u0647 \u0635\u0627\u0644\u062d\u06cc"},...{}}' :style='"object-fit:contain;\nheight:150px;"' class="img-fluid my-2" ></m-img><m-p v-bind='{...{},...{}}' :style='"border-radius:15px;"' class="font-weight-bold  p-2 shadow bg-primary text-white" >
                <template #default>باشگاه صالحی   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSection201 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section201'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mContentSlider4 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider4'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSection201,mH1,mP,mContentSlider4,mA,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
